import React, { useCallback, useEffect, useState, useContext } from 'react';
import QRCode from 'react-qr-code';
import { BetslipContext } from '../BetslipConf';
import { useFetchReservation } from '../../fetchReservation';
import SocialButtons from '../../my-bets/SocialButtons';
import { formatDateWithWeekDay } from '../../utils/formatDateWithWeekDay';
import { getBarcode } from '../../utils/getBarcode';
import { getBaseURL } from '../../utils/getBaseURL';
import { getConfiguration } from '../../utils/configuration';
import { getCurrencySymbol } from '../../utils/getCurrencySymbol';
import { getPrintableAmount } from '../../utils/getPrintableAmount';
import { getReservationCodeType } from '../../utils/getReservationCodeType';
import { getSplitDesc } from '../../utils/getSplitDesc';
import { oddToString } from '../../utils/oddToString';
import Loader from '../../../common/Loader';
import './reservationDetail.css';
import TuplesDetail from './TuplesDetail';
import { getLabel } from '../../../data/labels';
import { ReservationPrinter } from './ReservationPrinter';
import { xs_isMobile } from '../../..';
import { isLoadedInIframe } from '../../utils/isLoadedInIframe';
import { getBetslipPage } from '../../utils/getBetslipPage';

function getTicketType(type) {
    switch (type) {
        default:
        case 'singlebets':
            return getLabel('mybets.singola');
        case 'multibets':
            return getLabel('mybets.multipla');
        case 'systembets':
            return getLabel('mybets.sistema');
    }
}
function ReservationDetail(props) {
    const conf = getConfiguration();
    const useQrCode = getReservationCodeType() === 'qrCode';
    const betslipContext = useContext(BetslipContext);
    const reservationCode = betslipContext.reservationDetailCode;
    const [print, setPrint] = useState(false);
    const getTicketURL = useCallback((code) => {
        let baseURL = getBaseURL();
        if(isLoadedInIframe()) {
            try {
                baseURL = window.parent.origin;
            }catch(err) {
                console.error(err);
            }
        }
        const betslipPage = getBetslipPage(xs_isMobile);
        return `${baseURL}${betslipPage}?reservationCode=${code}`;
    }, []);

    function handleClose() {
        betslipContext.toggleReservationDetail();
    }

    function handlePrint() {
        setPrint(true);
    }

    function handleReload() {
        betslipContext.reloadReservedTicket(reservationCode);
    }

    const [data, setData] = useState(null);
    const [request] = useFetchReservation(reservationCode);
    const [showLoader, setShowLoader] = useState(true);
    useEffect(function () {
        let timeout = null;
        if (request.isLoading) {
            timeout = setTimeout(function () {
                setShowLoader(true);
            }, conf.lspt);
        } else {
            clearTimeout(timeout);
            setShowLoader(false);
            if (!request.isError) {
                setData(request.data);
            }
        }

        return () => {
            clearTimeout(timeout);
        };
    }, [request]);

    if (showLoader) {
        return <Loader error={request.isError} />;
    }

    const potentialWinnings = getPrintableAmount(data.potentialWinning, conf.cs.m, conf.cs.nd);
    const currency = getCurrencySymbol(conf.cs.ct);

    const handleClickShareNative = () => {
        const ticketUrl = getTicketURL(reservationCode)
        if (navigator.share && xs_isMobile) {
            navigator.share({
                url: ticketUrl,
                title: `${conf.sys} | ${getLabel('betslip.reservation.share')}`,
                text: getLabel('betslip.reservation.share_bet')
            })
        } else {
            props.onGoShareLinkView()
        }
    }

    let amount = data.printableAmountMulti;
    if (data.selectedContainer === 'singlebets') {
        amount = getPrintableAmount(data.amountSingle, conf.cs.m, conf.cs.nd);
    } else if (data.selectedContainer === 'systembets') {
        amount = getPrintableAmount(data.amountSystem, conf.cs.m, conf.cs.nd);
    }

    return (
        <>
            {print && <ReservationPrinter codeList={[reservationCode]} endFunction={() => setPrint(false)} />}
            <div id="xs-reservation-detail">
                <div className="reservation-wrapper">
                    <div className="header">
                        <span className="title">{getTicketType(data.selectedContainer)}</span>
                        <span className="close-button pointer" onClick={handleClose}>
                            <i className="fa fa-times"></i>
                        </span>
                    </div>
                    <div className="event-info">
                        <div className="event-info-desc">{getLabel('reservation_detail.events_number')}: <span className="event-info-count">{data.totalDraws}</span></div>
                        {data.selectedContainer === 'multibets' &&
                            <div className="event-info-odds-desc">{getLabel('reservation_detail.total_odds')}: <span className="event-info-odds-value">{data.totalOdd}</span></div>
                        }
                    </div>
                    <div className="reservation-info-container">
                        <div className="reservation-detail-container">
                            <div className="code-container">
                                {useQrCode ?
                                    <>
                                        <QRCode value={reservationCode} size="140" />
                                        <div className="code">{reservationCode}</div>
                                    </>
                                    :
                                    <div className="barcode-container">
                                        <img alt={reservationCode} src={getBarcode(reservationCode)} />
                                    </div>
                                }
                            </div>
                            <div className="ticket-info-container">
                                {data.selectedContainer === 'multibets' &&
                                    <div className="ticket-info-odds">
                                        <span className="ticket-info-odds-desc">{getLabel('reservation_detail.total_odds')}:</span>
                                        <span className="ticket-info-odds-value">{data.totalOdd}</span>
                                    </div>
                                }
                                <div className="event-info-amount">
                                    <div className="event-info-amount-desc">{getLabel('mybets.stake')}</div>
                                    <div className="event-info-amount-value">{amount}<span className="event-info-amount-currency">{currency}</span></div>
                                </div>
                            </div>
                            <div className="potential-winnings-container">
                                <span className="potential-winnings-desc">{getLabel('mybets.vincitapotenziale')}:</span>
                                <div className="potential-winnings-amount">{potentialWinnings}<span className="potential-winnings-currency">{currency}</span></div>
                            </div>
                            {!props.iframeMode &&
                                <div className="buttons-container">
                                    <button className='reservation_close' onClick={handleClose}>{getLabel('reservation_detail.close')}</button>
                                    <button className='reservation_print' onClick={handlePrint}>{getLabel('reservation_detail.print')}</button>
                                    {conf.iwh && <button className='reservation_share' onClick={handleClickShareNative}>{getLabel('betslip.reservation.share')}</button>}
                                    <button className='reservation_load' onClick={handleReload}>{getLabel('reservation_detail.load')}</button>
                                    <SocialButtons message={getLabel('reservation_detail.share_ticket')} ticketUrl={getTicketURL(reservationCode)} />
                                </div>
                            }
                        </div>
                        <div className="selections-container">
                            {data.selections.map(s => {
                                const formattedDate = formatDateWithWeekDay(s.timestamp).dayTime;
                                const [date, time] = getSplitDesc(formattedDate);
                                const [team1, team2] = getSplitDesc(s.descEvent);
                                return (
                                    <div className="selection" key={`${s.pal}_${s.avv}`}>
                                        <div className="selection-info">
                                            <div className="event-summary">
                                                <div className="event-summary-date-and-time">
                                                    <span className="event-summary-date">{date}</span>
                                                    <span className="event-summary-time">{time}</span>
                                                </div>
                                                <div className="event-summary-competitors-and-scores">
                                                    <div className="event-summary-competitors-wrapper">
                                                        <span className="event-summary-competitors-team1">{team1}</span>
                                                        {team2 &&
                                                            <span className="event-summary-competitors-team2">{team2}</span>
                                                        }
                                                    </div>
                                                    <div className="score-container">
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="event-alias-container">
                                                <span className="event-alias">{s.alias}</span>
                                            </div>
                                        </div>
                                        {s.bets.map(b => {
                                            return (
                                                <div className="bet-info" key={`${b.scomSogei}_${b.handicap}`}>
                                                    <span className="bet-info-desc">{b.descBet}</span>
                                                    <div className="desc-and-odd-container">
                                                        <span className="bet-info-draw-desc">{b.descDraw}</span>
                                                        <span className="bet-info-odd">{oddToString(b.odd)}</span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                            {data.selectedContainer === 'systembets' &&
                                <TuplesDetail selections={data.userSystemSelections} combs={data.calculatedSystemData.comb} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ReservationDetail;